/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <Card>
    <v-list two-line class="scroll-y mfm-list-card primary">
      <template v-for="(item, index) in items">
        <v-list-tile :key="index" avatar ripple @click="clickItem(item)"
          :class="{activelist: item.feeder_id == selectedFeedId}">
          <v-list-tile-content>
            <v-list-tile-title class="text-capitalize extraGreen--text fs-16">{{ item.type }}
            </v-list-tile-title>
            <v-list-tile-sub-title class="primaryText--text">{{ item.name }}</v-list-tile-sub-title>
            <v-list-tile-sub-title>
              <v-layout>
                <v-flex xs6>
                  <span>
                    {{ $t('Export (kWh)') }} : <span :class="item.export != null ? 'number--text' : 'error--text'">{{ item.export == null ? 'No Data' : item.export}}</span>
                  </span>
                </v-flex>
                <v-flex xs6>
                  <span>
                    {{ $t('AC Power (KW)') }} : <span :class="item.ac_power != null ? 'number--text' : 'error--text'">{{ item.ac_power == null ? 'No Data' : item.ac_power}}</span>
                  </span>
                </v-flex>
              </v-layout>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="index < items.length-1" :key="`divider-${index}`"></v-divider>
      </template>
    </v-list>
  </Card>
</template>

<script>
import { mapGettersMixin } from '@/util/mixin/index'
import list from '@/services/mfm.js'
import {
  mapMutations
} from 'vuex'
import moment from 'moment'
export default {
  mixins: [ mapGettersMixin ],
  props: ['plantId', 'blockId', 'date'],
  data() {
    return {
      items: [],
      interval: null,
      selectedFeedId: 1
    }
  },
  created() {
    if (this.isReload) {
      this.setIntervalWithoutDelay(this.callAllApi)
    }
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getListData(this.plantId, this.blockId, this.date)
    },
    async getListData(plantId, blockId, date) {
      let param = {
        plantId,
        blockId,
        date
      }
      let response = await list.getList(param)
      if (response.status === 200) {
        this.items = response.data.message
        this.$emit('initalGraph', response.data.message)
      }
    },
    clickItem(event) {
      this.selectedFeedId = event.feeder_id
      this.$emit('onClickCard', event)
    }
  },
  watch: {
    date() {
      this.callAllApi()
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }
}
</script>

<style scoped>
  .mfm-list-card {
    height: calc(100vh - 297px);
    overflow: auto;
  }

  .activelist {
    border-radius: 2px;
    background-color: var(--v-primary-darken1);
    color: var(--v-primaryText-base);
  }

  .activelist .text--primaryText {
    color: var(--v-primaryText-base);
  }
</style>
